import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 2rem 3rem;
  max-width: 1200px;
  margin: 0 auto;
`

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.brand};
  font-weight: bold;
  font-size: 3rem;

  text-align: center;
  margin: 2rem 0;
  text-transform: uppercase;
`

export const InputContainer = styled.div`
  width: 100%;
  position: relative;
  margin: 0 auto 1.5rem auto;

  @media (min-width: 768px) {
    width: 30rem;
  }

  @media (min-width: 992px) {
    width: 35rem;
    margin-bottom: 3.5rem;
  }
`

export const InputBar = styled.input`
  width: 100%;
  height: 3.5rem;
  margin: 0;
  background: ${({ theme }) => theme.colors.boxBackground};
  border-radius: 5rem;
  border: none;
  font-size: 1.4rem;
  padding: 0 1rem 0 2rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fonts.brand};
  box-sizing: border-box;

  &::placeholder {
    opacity: 0.8;
    font-family: ${({ theme }) => theme.fonts.brand};
  }
`

export const ButtonSearch = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  width: 7rem;
  height: 3.5rem;
  border-radius: 5rem;
  border: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: initial;
  }
`

export const Columns = styled.ul`
  padding-left: 4rem;
  list-style-type: none;
  column-count: 1;
  column-width: 100%;

  @media screen and (min-width: 480px) {
    column-count: 2;
  }

  @media screen and (min-width: 768px) {
    column-count: 3;
  }

  @media screen and (min-width: 992px) {
    column-count: 4;
  }
`

export const CountryWrap = styled.li`
  padding: 0;

  a {
    display: block;
    color: ${({ theme }) => theme.colors.text.primary};
    font-family: ${({ theme }) => theme.fonts.brand};

    font-size: 1.8rem;
    &:hover {
      text-decoration: underline;
    }
  }
`
